import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TestimonialGrid = ({ departmentType, orgSize, useCase }) => {
  const [viewMode, setViewMode] = useState('all');

  const testimonials = [
  {
    id: 1,
    type: 'video',
    organization: 'Department of Finance',
    author: 'James Marape',
    position: 'HR Director',
    departmentType: 'government',
    orgSize: 'large',
    useCase: 'compliance',
    rating: 5,
    date: '2025-12-15',
    content: 'The compliance automation saved us from K380,000 in annual penalties. Real-time alerts ensure we never miss a deadline.',
    videoThumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1891a8c3e-1768604060126.png",
    alt: 'Papua New Guinean HR Director discussing compliance automation benefits',
    duration: '2:45',
    verified: true
  },
  {
    id: 3,
    type: 'photo',
    organization: 'Digicel PNG',
    author: 'Michael Kombri',
    position: 'Operations Manager',
    departmentType: 'private',
    orgSize: 'large',
    useCase: 'workforce',
    rating: 5,
    date: '2025-11-22',
    content: 'Workforce analytics transformed our planning. We reduced overtime costs by 42% and improved resource allocation across all departments.',
    photo: "https://img.rocket.new/generatedImages/rocket_gen_img_1cfcd5f2f-1768445733273.png",
    alt: 'Diverse Papua New Guinean operations team celebrating workforce management success',
    verified: true
  },
  {
    id: 4,
    type: 'written',
    organization: 'PNG Ports Corporation',
    author: 'Grace Torato',
    position: 'Compliance Officer',
    departmentType: 'private',
    orgSize: 'large',
    useCase: 'document',
    rating: 5,
    date: '2025-12-30',
    content: 'Document expiration alerts prevented 45 compliance violations in our first year. The automated renewal workflow saved countless hours of manual tracking.',
    verified: true
  },
  {
    id: 5,
    type: 'video',
    organization: 'Western Province Health Authority',
    author: 'Dr. Sarah Konga',
    position: 'Chief Medical Officer',
    departmentType: 'government',
    orgSize: 'medium',
    useCase: 'compliance',
    rating: 5,
    date: '2026-01-05',
    content: 'Managing compliance across 12 rural health centers was impossible before. Now we have real-time visibility and zero violations.',
    videoThumbnail: 'https://img.rocket.new/generatedImages/rocket_gen_img_1891a8c3e-1768604060126.png',
    alt: 'Papua New Guinean medical officer explaining health sector compliance improvements',
    duration: '3:12',
    verified: true
  },
  {
    id: 6,
    type: 'written',
    organization: 'Air Niugini',
    author: 'Peter Waninara',
    position: 'HR Manager',
    departmentType: 'private',
    orgSize: 'large',
    useCase: 'workforce',
    rating: 5,
    date: '2025-11-18',
    content: 'Leave management automation eliminated double-bookings and scheduling conflicts. Employee satisfaction increased 35% in the first quarter.',
    verified: true
  },
  {
    id: 8,
    type: 'written',
    organization: 'Lae Chamber of Commerce',
    author: 'Margaret Kombri',
    position: 'Executive Director',
    departmentType: 'private',
    orgSize: 'small',
    useCase: 'compliance',
    rating: 5,
    date: '2026-01-12',
    content: 'As a small organization, we couldn\'t afford compliance mistakes. The automated system gave us enterprise-level protection at an affordable price.',
    verified: true
  },
  {
    id: 9,
    type: 'video',
    organization: 'Kumul Petroleum Holdings',
    author: 'David Torato',
    position: 'Chief HR Officer',
    departmentType: 'private',
    orgSize: 'large',
    useCase: 'document',
    rating: 5,
    date: '2025-12-28',
    content: 'Digital document management transformed our audit readiness. We passed our last compliance audit with 100% documentation accuracy.',
    videoThumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1db54eefe-1770857695017.png",
    alt: 'Papua New Guinean petroleum industry executive discussing document management success',
    duration: '2:18',
    verified: true
  }];


  const filteredTestimonials = testimonials?.filter((testimonial) => {
    if (viewMode !== 'all' && testimonial?.type !== viewMode) return false;
    if (departmentType !== 'all' && testimonial?.departmentType !== departmentType) return false;
    if (orgSize !== 'all') {
      if (orgSize === 'small' && testimonial?.orgSize !== 'small') return false;
      if (orgSize === 'medium' && testimonial?.orgSize !== 'medium') return false;
      if (orgSize === 'large' && testimonial?.orgSize !== 'large') return false;
    }
    if (useCase !== 'all' && testimonial?.useCase !== useCase) return false;
    return true;
  });

  const renderStars = (rating) => {
    return (
      <div className="flex items-center gap-1">
        {[...Array(5)]?.map((_, index) =>
        <Icon
          key={index}
          name="Star"
          size={14}
          className={index < rating ? 'text-amber-400 fill-amber-400' : 'text-gray-300 dark:text-gray-600'} />

        )}
      </div>);

  };

  return (
    <div className="space-y-6">
      {/* View Mode Toggle */}
      <div className="flex items-center gap-2">
        <Button
          variant={viewMode === 'all' ? 'default' : 'outline'}
          size="sm"
          onClick={() => setViewMode('all')}>
          
          All Testimonials
        </Button>
        <Button
          variant={viewMode === 'video' ? 'default' : 'outline'}
          size="sm"
          iconName="Video"
          onClick={() => setViewMode('video')}>
          
          Video
        </Button>
        <Button
          variant={viewMode === 'written' ? 'default' : 'outline'}
          size="sm"
          iconName="FileText"
          onClick={() => setViewMode('written')}>
          
          Written
        </Button>
        <Button
          variant={viewMode === 'photo' ? 'default' : 'outline'}
          size="sm"
          iconName="Image"
          onClick={() => setViewMode('photo')}>
          
          Photo
        </Button>
      </div>
      {/* Testimonials Grid */}
      {filteredTestimonials?.length === 0 ?
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-12 text-center">
          <Icon name="Search" size={48} className="text-gray-300 dark:text-gray-600 mx-auto mb-4" />
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">No Testimonials Found</h3>
          <p className="text-sm text-gray-600 dark:text-gray-400">Try adjusting your filters to see more results.</p>
        </div> :

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredTestimonials?.map((testimonial) =>
        <div
          key={testimonial?.id}
          className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 overflow-hidden hover:shadow-md transition-shadow">
          
              {/* Media */}
              {testimonial?.type === 'video' &&
          <div className="relative aspect-video bg-gray-900">
                  <img
              src={testimonial?.videoThumbnail}
              alt={testimonial?.alt}
              className="w-full h-full object-cover" />
            
                  <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                    <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-emerald-700 transition-colors">
                      <Icon name="Play" size={28} className="text-white ml-1" />
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded">
                    {testimonial?.duration}
                  </div>
                </div>
          }
              {testimonial?.type === 'photo' &&
          <div className="aspect-video bg-gray-100 dark:bg-slate-700">
                  <img
              src={testimonial?.photo}
              alt={testimonial?.alt}
              className="w-full h-full object-cover" />
            
                </div>
          }

              {/* Content */}
              <div className="p-5">
                <div className="flex items-center justify-between mb-3">
                  {renderStars(testimonial?.rating)}
                  {testimonial?.verified &&
              <div className="flex items-center gap-1 text-emerald-600 dark:text-emerald-400">
                      <Icon name="CheckCircle" size={14} />
                      <span className="text-xs font-medium">Verified</span>
                    </div>
              }
                </div>

                <p className="text-sm text-gray-700 dark:text-gray-300 mb-4 line-clamp-4">"{testimonial?.content}"</p>

                <div className="border-t border-gray-200 dark:border-slate-600 pt-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 bg-emerald-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <Icon name="User" size={20} className="text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                        {testimonial?.author}
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400 truncate">{testimonial?.position}</div>
                      <div className="text-xs text-gray-500 dark:text-gray-400 truncate">{testimonial?.organization}</div>
                    </div>
                  </div>
                </div>

                <div className="mt-3 text-xs text-gray-400 dark:text-gray-500">
                  {new Date(testimonial.date)?.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
                </div>
              </div>
            </div>
        )}
        </div>
      }
    </div>);

};

export default TestimonialGrid;